import React from 'react';
import { useState, useEffect } from 'react';
import { attendanceApi } from '../../services';
import moment from "moment";

export default function MissingAttendance() {
  const [missingUserAttendanceList, setMissingUserAttendanceList] = useState([]);
  useEffect(() => {
    fetchMissingUserAttendance();
  }, []);

  const fetchMissingUserAttendance = () => {
    attendanceApi.missingAttendance({}).then((resp) => {
      setMissingUserAttendanceList(resp.data.leaveDay)
    });
  }

  return (
    <React.Fragment>
      <div className='grid'>
        <div className='col-12'>
          <h1>Total no of missing attendace : <strong>{missingUserAttendanceList.length}</strong></h1>
        </div>
      </div>
      <div className="missing-attendance-dates">
        <ul>
          {missingUserAttendanceList.map(e => <li className={"D-Thu"}><span>{moment(e).format('ddd DD-MM-YYYY')}</span></li>)}
        </ul>
      </div>
    </React.Fragment>
  )
}